import React from 'react'
import { Dropdown } from 'antd'
import type { MenuProps } from 'antd'
import checkIcon from 'assets/images/check-mark-16.svg'
import chevronDownIcon from 'assets/images/chevron-down-24.svg'
import priorityIcon from 'assets/images/property-priority.svg'
import { useTranslation } from 'react-i18next'
import { PRIORITY, Priority } from '../../modules/TodoItem'
import styles from './style.module.scss'

interface PrioritySelectorProps {
  value: Priority
  onChange: (value: Priority) => void
  disabled?: boolean
}

interface PriorityOption {
  key: string
  label: string
  value: Priority
}

const PrioritySelector: React.FC<PrioritySelectorProps> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation()

  const priorityLabels: Record<Priority, string> = {
    [PRIORITY.HIGH]: t('todo.editor.high'),
    [PRIORITY.MEDIUM]: t('todo.editor.medium'),
    [PRIORITY.LOW]: t('todo.editor.low'),
  }

  const priorityOptions: PriorityOption[] = [
    { key: PRIORITY.HIGH, label: t('todo.editor.high'), value: PRIORITY.HIGH },
    { key: PRIORITY.MEDIUM, label: t('todo.editor.medium'), value: PRIORITY.MEDIUM },
    { key: PRIORITY.LOW, label: t('todo.editor.low'), value: PRIORITY.LOW },
  ]

  const getPriorityItems = (): MenuProps['items'] => {
    return priorityOptions.map((priority) => ({
      key: priority.key,
      label: (
        <div className={styles.menuItem}>
          <div className={styles.priorityInfo}>
            <div className={styles.priorityLabel}>{priority.label}</div>
          </div>
          {value === priority.value && (
            <img src={checkIcon} alt="Selected" className={styles.checkIcon} />
          )}
        </div>
      ),
      onClick: () => onChange(priority.value),
    }))
  }

  return (
    <div className={styles.prioritySelector}>
      <div className={styles.titleIconWrapper}>
        <img src={priorityIcon} alt="Priority" className={styles.titleIcon} />
      </div>
      <Dropdown
        menu={{ items: getPriorityItems() }}
        trigger={['click']}
        placement="bottomLeft"
        overlayClassName="contextMenu"
        getPopupContainer={() => document.body}
        disabled={disabled}
      >
        <button
          className={`${styles.priorityButton} ${disabled ? styles.dimmed : ''}`}
          disabled={disabled}
        >
          <div className={styles.priorityDetails}>
            <div className={styles.priorityInfo}>
              <div className={styles.priorityLabel}>{priorityLabels[value]}</div>
            </div>
          </div>
          <img src={chevronDownIcon} alt="More" className={styles.chevronIcon} />
        </button>
      </Dropdown>
    </div>
  )
}

export default PrioritySelector
